<div class="progress">
  <div class="progress-bar" [style.width.%]="progress" role="progressbar"></div>
</div>
